<template>
  <div class="pr">PR</div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'PRBadge'
})
</script>

<style lang="scss" scoped>
@use 'src/styles/abstracts/mixins';
.pr {
  padding: 5px 11px;
  background-color: rgba(58, 58, 58, 0.8);
  color: #fff;
  font-size: 13px;
  line-height: 13px;

  @include mixins.mediaMax('sm') {
    padding: 4px 8px;
    font-size: 11px;
    line-height: 11px;
  }
}
</style>
